module.exports = __webpack_public_path__ + "img/kongjiang.05bce25e.png";